import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import WidgetsIcon from '@mui/icons-material/Widgets';
import SchoolIcon from '@mui/icons-material/School';
import CategoryIcon from '@mui/icons-material/Category';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CodeIcon from '@mui/icons-material/Code';
import { FileUpload } from "@mui/icons-material";
import GroupIcon from "@mui/icons-material/Group";

// Sidebar array
export const sidebarArray = [
  {
    icon: <DashboardIcon fontSize="small" />,
    label: "Dashboard",
    url: "dashboard",
  },
  {
    icon: <WidgetsIcon fontSize="small" />,
    label: "Category",
    url: "category-management",
  },
  {
    icon: <SchoolIcon fontSize="small" />,
    label: "Curriculum",
    url: "curriculum-management",
  },
  {
    icon: <CategoryIcon fontSize="small" />,
    label: "Products",
    url: "product-management",
  },
  {
    icon: <WidgetsIcon fontSize="small" />,
    label: "Heading",
    url: "heading-management",
  },
  {
    icon: <CodeIcon fontSize="small" />,
    label: "Code",
    url: "code-management",
  },
  // {
  //   icon: <AccountTreeIcon fontSize="small" />,
  //   label: "Main Module",
  //   url: "main-module-management",
  // },
  {
    icon: <ApartmentIcon fontSize="small" />,
    label: "School",
    url: "school-management",
  },
  {
    icon: <GroupIcon fontSize="small" />,
    label: "Role Management",
    url: "role-management",
  },
  {
    icon: <ManageAccountsIcon fontSize="small" />,
    label: "CMS Settings",
    url: "cms-settings",
  },
  {
    icon: <ManageAccountsIcon fontSize="small" />,
    label: "Settings",
    url: "settings",
  },
  {
    icon: <FileUpload fontSize="small" />,
    label: "File Upload",
    url: "glb-file",
  },
 
];

export const setCookies = (key, value) => {
  document.cookie = key + "=" + (value || "") + "; path=/";
};

export const getCookies = (key) => {
  const value = ("; " + document.cookie).split(`; ${key}=`).pop().split(";")[0];
  return value;
};

export const deleteCookies = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

// To restrict empty space in textfield
export const handleRestrictEmptySpace = (e, setFormData, name) => {
  if(e?.which === 32) {
    setFormData((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  }
}

// To manage custom multilevel menu in sidebar
export const sideBarIncludedIndex = []

export const storeSidebarIndex = (index) => {
  sideBarIncludedIndex.push(index)
}

export const removeSidebarIndex = (index) => {
  const filter = sideBarIncludedIndex.indexOf(index);
  sideBarIncludedIndex.splice(filter, 1); 
}

// To manage open/close sidebar drawer with popover 
export let sidebarDrawerInit = false

export const handleSidebarDrawerInit = () => {
  sidebarDrawerInit = !sidebarDrawerInit
  return sidebarDrawerInit
}

